var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigipassFace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_50",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 29,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8716 33.7169V6.69653H6.79474V33.7169H32.8716Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0581 22.7952C15.7509 21.5085 15.5879 20.1629 15.5879 18.7778C15.5879 17.2425 16.789 15.9979 18.2706 15.9979C19.7523 15.9979 20.9535 17.2425 20.9535 18.7778C20.9535 21.8165 22.1307 24.5704 24.0382 26.5764L25.0248 27.3105C27.0002 28.7803 29.3708 29.5709 31.8028 29.5709H33.0168",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.839 27.2886C20.1316 31.2823 24.3266 33.6852 28.8113 33.6852H30.0328",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5701 14.2911C13.8775 12.5104 15.9445 11.3608 18.2705 11.3608C22.2237 11.3608 25.4285 14.6815 25.4285 18.7778C25.4285 18.84 25.4293 18.9021 25.4311 18.9638C25.5234 22.3544 28.2612 25.0263 31.5345 25.0263H33.0165",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9823 33.6852C13.4938 29.9935 11.2904 24.9926 11.1225 19.4599",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20404 4.24534C13.8619 -0.470477 23.6032 0.194123 27.8358 4.68226",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8317 7.51022C32.4933 11.5005 33.435 15.4262 33.0983 20.7423C32.9505 23.075 31.4952 21.6576 29.8317 20.5694",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71944 6.42191C4.05794 10.4122 2.2345 13.4395 2.57118 18.7556C2.66088 20.1712 1.53898 22.5405 1.01479 23.9415C0.788956 24.5451 3.21611 24.7177 3.74795 25.5951C4.78164 27.3002 1.88533 32.1776 4.21421 34.7169C5.87761 35.8051 7.52908 34.6836 9.20458 35.0796C10.3322 35.3462 9.9325 38.5809 9.86995 38.7072",
    stroke: "#3936EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigipassFace);
export default __webpack_public_path__ + "static/media/digipass-face.b6f9bce85b8fa464bc9673d5118106a5.svg";
export { ForwardRef as ReactComponent };